//
//
import React, { Component } from 'react';
import FryKnob from '../../components/Knob/knob';
import Totals from '../../components/displays/Totals/totals';
import Lock from '../../components/Toggle/Lock/lock';
import Modal from 'react-responsive-modal';
import Instructions from '../../components/Instructions/instructions';

import logo from '../../../img/fry-logo-w.png';
import './payment.scss';


class Payment extends Component {
  constructor(props){
    super(props);
    this.state = {
      modalOpen: false,
      dpKnobLocked: false,
      mpKnobLocked: false,
      mKnobLocked: false,
      showDiscount: true,
      originalInvestment: 0,
      // Pay-in-full discount is calculated off (initialCost - discounts) only.
      // These are plumbed in from Consultation and are deliberately kept
      // separate from `investment`, which stays the full amount owed.
      initialCost: 0,
      discounts: 0,
      initFeeAmount: 0,
      feeButtonText: '',
      feeDisabled: false,
      addFeeButtonLabel: '',
      removeFeeButtonLabel: ''
    };

    this.onDownPaymentChange = this.onDownPaymentChange.bind(this);
    this.onMonthlyPaymentsChange = this.onMonthlyPaymentsChange.bind(this);
    this.onMonthsChange = this.onMonthsChange.bind(this);
    this.onInvestmentChange = this.onInvestmentChange.bind(this);
    this.recalculateTotals = this.recalculateTotals.bind(this);
    this.setKnobLock = this.setKnobLock.bind(this);
    this.setKnobState = this.setKnobState.bind(this);
    this.handleAddFeeClick = this.handleAddFeeClick.bind(this);
    this.handleFeeInputUpdate = this.handleFeeInputUpdate.bind(this);

    this.calculating = false;
  }

  componentWillMount(){
    
  }

  setData(data){
    console.log("payment.js - setData  " +data.MonthlyPaymentsKnobSettings.initial_value)
    this.initAppData(data);
  }

  setText(data){

    let str1 = data.discountPopupHeaderLabel.split("|payFullPerc|")[0];
    let str2 = data.discountPopupHeaderLabel.split("|payFullPerc|")[1];
    
    let newPopupHeaderLabel = str1 + this.state.perc + str2;

    let str3 = data.discountPopupContent.split("|payFullPerc|")[0];
    let str4 = data.discountPopupContent.split("|payFullPerc|")[1];

    let newPopupContent = str3 + this.state.perc + str4;

    this.setState({
      downPaymentLockLabel: data.downPaymentLockLabel,
      monthlyPaymentsLockLabel: data.monthlyPaymentsLockLabel,
      monthsLockLabel: data.monthsLockLabel,
      discountPopupHeaderLabel: newPopupHeaderLabel,
      discountPopupContent: newPopupContent,
      discountPriceLabel: data.discountPriceLabel,
      instructionsText: data.instructionsText,
      feeButtonText: this.state.feeDisabled ? data.removeFeeButtonLabel : data.addFeeButtonLabel,
      addFeeButtonLabel: data.addFeeButtonLabel,
      removeFeeButtonLabel: data.removeFeeButtonLabel
    });

    if(this.refs.display) this.refs.display.setText(data);
    if(this.refs.instructions) this.refs.instructions.setText(data);
  }

  initAppData(data){
    // manipulate the value if using value from Consultation Screen

    this.setState({
      perc: data.PayInFullPercentage,
      investment: data.DownPaymentKnobSettings.value_max,
      downpayment: data.DownPaymentKnobSettings.initial_value,
      payments: data.MonthlyPaymentsKnobSettings.initial_value,
      months: data.MonthsKnobSettings.initial_value,
      maxDownPayment: data.DownPaymentKnobSettings.value_max,
      maxPayments: data.MonthlyPaymentsKnobSettings.value_max,
      maxMonths: data.MonthsKnobSettings.value_max,
      minDownPayment: data.DownPaymentKnobSettings.value_min,
      minPayments: data.MonthlyPaymentsKnobSettings.value_min,
      minMonths: data.MonthsKnobSettings.value_min,
		  dpkRoundNumber: data.DownPaymentKnobSettings.roundNumber,
		  mpkRoundNumber: data.MonthlyPaymentsKnobSettings.roundNumber,
      mkRoundNumber: data.MonthsKnobSettings.roundNumber,
      zeroMonthsDownPaymentMin: data.DownPaymentKnobSettings.zeroMonthsDownPaymentMin,
      zeroDownPaymentMonthsMax: data.MonthsKnobSettings.zeroDownPaymentMonthsMax
    });

    this.setKnobState(
      data.DownPaymentKnobSettings,
      data.MonthlyPaymentsKnobSettings,
      data.MonthsKnobSettings,
      data.DownPaymentKnobSettings.value_max
    );

    this.refs.dpKnob.dataLoaded();
    this.refs.mpKnob.dataLoaded();
    this.refs.mKnob.dataLoaded();

    // SET INITIAL STATE OF KNOBS
    if(!this.calculating) this.onInvestmentChange(data.DownPaymentKnobSettings.value_max);
    // SET INITIAL STATE OF FEE BUTTON
    this.setFeeButtonDisabled(true)
  }

  setFeeButtonDisabled(_boo){
    let btn = document.getElementById('fee-button');
    btn.disabled = _boo;
  }

  onDownPaymentChange(amount){
    if(!this.calculating) this.recalculateTotals("dp", amount);
  }

  onMonthlyPaymentsChange(amount){
    if(!this.calculating) this.recalculateTotals("mp", amount);
  }

  onMonthsChange(amount){
    if(!this.calculating) this.recalculateTotals("m", amount);
  }

  onInvestmentChange(amount, initialCost, discounts){
    console.log("payment - onInvestmentChange() -- "+ amount);
//
// this is NOT DRY... need to refactor
//

    // initialCost/discounts are only supplied by Consultation. Internal callers
    // (initial knob setup, add/remove fee) omit them, so leave the stored
    // discount basis untouched rather than zeroing it out.
    if(initialCost !== undefined) this.setState({ initialCost: initialCost });
    if(discounts !== undefined) this.setState({ discounts: discounts });

    let newAmount = amount;// == undefined ? this.props.investment : amount;
    let tempDPObj = this.state.DownPaymentKnobSettings;
    let tempMPObj = this.state.MonthlyPaymentsKnobSettings;
    
    if(this.state.investment !== newAmount){
      this.setState({
        investment: newAmount,
        showDiscount: true
      });
    }

    tempDPObj.value_max = this.roundUp(this.state.DownPaymentKnobSettings.roundNumber, newAmount);
    tempMPObj.value_max = this.roundUp(
      tempMPObj.roundNumber,
      Math.round( newAmount / this.state.MonthsKnobSettings.value_min )
    );
   
    this.setKnobState(
      tempDPObj,
      tempMPObj,
      this.state.MonthsKnobSettings,
      newAmount
    );

    this.recalculateTotals("total", amount);
  }

  handleAddFeeClick(e){
    // get value from input
    let feeInput = document.getElementById('fee-amount');
    console.log('originalInvestment >', this.state.originalInvestment)

    if(this.state.feeDisabled){
      //
      feeInput.value = '';
      feeInput.disabled = false;
      this.setState({feeButtonText: this.state.addFeeButtonLabel});
      this.setState({feeDisabled: false});
      //
      console.log('set to Org', this.state.originalInvestment)
      this.onInvestmentChange(this.state.originalInvestment);
      this.setButtonStatus(feeInput.value)

    } else {
      //
      feeInput.disabled = true;
      this.setState({feeButtonText: this.state.removeFeeButtonLabel});
      this.setState({feeDisabled: true});
      this.setState({originalInvestment: this.state.investment});
      //
      let newFee = feeInput.value <= 0 ? 0 : parseInt(feeInput.value, 10);
      console.log('newFee >',newFee)
      console.log('set to New', this.state.investment + newFee)
      this.onInvestmentChange(this.state.investment + newFee);
      this.setButtonStatus(newFee)
    }

  }

  setButtonStatus(_val){
    if(_val > this.state.initFeeAmount && _val != undefined){
      this.setFeeButtonDisabled(false)
    } else { 
      this.setFeeButtonDisabled(true)
    }
  }

  handleFeeInputUpdate(e){ this.setButtonStatus( e.currentTarget.value ) }

  ///
  ///
  ///

  recalculateTotals(who, amount){

    this.calculating = true;
    // do things here to manipulate view

    let skip = false;
    let investment = this.state.investment;
    let amountOwed = 0;
    //
    let dp = this.state.downpayment;
    let mp = this.state.payments;
    let m = this.state.months;
    //
    let dpState = dp;
    let mpState = mp;
    let mState = m;
    //
    let DPMinTwoFourMonths = this.state.zeroMonthsDownPaymentMin;
    let MonthsMaxDPZero = this.state.zeroDownPaymentMonthsMax;
    //
    let maxDownPayment = this.state.investment;
    let maxPayments = this.state.maxPayments;
    let maxMonths = this.state.maxMonths;
    //
    let minDownPayment = this.state.minDownPayment;
    let minPayments = this.state.minPayments;
    let minMonths = this.state.minMonths;
    //
    let dpLocked = this.state.dpKnobLocked;
    let mpLocked = this.state.mpKnobLocked;
    let mLocked = this.state.mKnobLocked;

    let zSkip = false;

    switch( who ){
      case "dp":

        if( dpLocked || amount < minDownPayment || amount > maxDownPayment ){
          dp = maxDownPayment;
          this.showDiscountPopup();
          skip = true;
        } else {
          
          dp = amount;
          amountOwed = investment - dp;

          //check if dp is set to zero and adjust MP and M
          if( (dp <= DPMinTwoFourMonths) && (m > MonthsMaxDPZero) ){
            if(!mLocked && !mpLocked){
              m = MonthsMaxDPZero;
              mp = Math.round(amountOwed / m);
            } else if(dp <= DPMinTwoFourMonths){
              dp = DPMinTwoFourMonths;
              amountOwed = investment - dp;
            }
            zSkip = true;
          }

          if(!zSkip && (dp < maxDownPayment) ){

            // set Monthly Payments if able
            if( !mpLocked ){
              if(mp >= minPayments && mp <= maxPayments){
                mp = Math.ceil(amountOwed / m);
              }
            // set Months if Monthly payment fails and Months able   
            } else if( !mLocked && m >= minMonths && m <= maxMonths ) {
                      
              m = Math.ceil( (investment - dp) / mp );

              // Reset Months - out of range High
              if(m > maxMonths){
                m = maxMonths;
                dp = dpState;
              }
              // Reset Months - out of range Low
              if(m < minMonths){
                m = minMonths;
                dp = dpState;
              }
            } 
            
          } else if(!zSkip) {
            // set other dials to minimums and show popup
            mp = minPayments;
            dp = maxDownPayment;
            // reset amount owed based on new data
            amountOwed = investment - dp;
            this.showDiscountPopup();
          }
        }

        amountOwed = investment - dp;

        break;

      case "mp":

        if( mpLocked || amount < minPayments || amount > maxPayments ){
          skip = true;
        } else {
          
          mp = amount;
          amountOwed = investment - dp;

          if( (dp < DPMinTwoFourMonths) && (m >= MonthsMaxDPZero) ){

            if(dpLocked){
              
              if(mp <= mpState){
                m = MonthsMaxDPZero;
                mp = mpState;
              } else {
                m = Math.round( (amountOwed / mp) );
              }
              
            } else if(mLocked){

              dp = DPMinTwoFourMonths;
              amountOwed = investment - dp;
              mp = Math.round(amountOwed / m);
            
            } else {

              dp = Math.round( investment - (mp * m) );
              dp = dp < DPMinTwoFourMonths ? DPMinTwoFourMonths : dp;
              amountOwed = investment - dp; 
              
            }

            zSkip = true;
          }

          if( !zSkip ){

            if( mp < maxPayments ){
              if( !mLocked && m >= minMonths && m <= maxMonths ) {
                
                m = Math.round( (amountOwed / mp) );
                
                if(m > maxMonths){
                  m = maxMonths;
                  mp = mp > mpState ? mp : mpState;
                }
                if(m < minMonths){
                  m = minMonths;
                  mp = mp < mpState ? mp : mpState;
                }

              } else {

                if( !dpLocked && dp >= minDownPayment && dp <= maxDownPayment ) {
                  
                  dp = Math.ceil(investment - (mp * m));
                  amountOwed = investment - dp;
                } else if(amount < mpState){
                  mp = amount;
                  dp = Math.ceil(investment - (mp * m));
                  amountOwed = investment - dp;
                } else {
                  mp = mpState;
                }
              }

            } else {
              dp = minDownPayment;
              amountOwed = investment - dp;
              m = minMonths;
            }
          }
        }

        if(dp >= maxDownPayment) this.showDiscountPopup();

        break;
  
      case "m":

        if( mLocked || amount < minMonths || amount > maxMonths ){
          skip = true;
        } else {
          
          m = amount;
          amountOwed = investment - dp;
          
          if( (dp <= DPMinTwoFourMonths) && (m > MonthsMaxDPZero) ){
            if( !dpLocked && !mpLocked ){
              dp = DPMinTwoFourMonths;
              amountOwed = investment - dp;
              mp = Math.ceil(amountOwed / m);
            }
            if( (dpLocked) && (m > MonthsMaxDPZero) ){
              if(dp !== DPMinTwoFourMonths) m = MonthsMaxDPZero;
            }
            if( mpLocked ){
              dp = Math.round( investment - (mp * m) );
              dp = dp < DPMinTwoFourMonths ? DPMinTwoFourMonths : dp;
              amountOwed = investment - dp;
            }
            zSkip = true;
          }

          if( !zSkip && !mpLocked ){
            if( (mp >= minPayments) && (mp <= maxPayments) ){
              mp = Math.ceil(amountOwed / m);
            }
          } else if( !zSkip && ((!dpLocked) && (dp >= minDownPayment) && (dp <= maxDownPayment)) ){

            dp = Math.round( investment - (mp * m) );
            dp = dp < minDownPayment ? minDownPayment : dp;
            amountOwed = investment - dp;
            m = Math.round( (amountOwed / mp) );
          }
        }

        break;
      
      case "total":

        investment = amount;
        this.setState({ investment: investment });
        amountOwed = amount - dp;
        mp = Math.ceil(amountOwed / m);
        
        break;

      default:
        amountOwed = 0;
        mp = 0;
        break;
    }
    
    if(dpLocked) dp = dpState;
    if(mpLocked) mp = mpState;
    if(mLocked) m = mState;

    if(!skip){
      let totalsObject = {
        downpayment: dp,
        payments: mp,
        months: m,
        investment: investment
      };
      this.setState( totalsObject );
      this.setValues( totalsObject );
    }
    this.calculating = false;
  } 

  roundUp(r,v){
  	return Math.ceil(v / r) * r;
  }

  ///
  ///
  ///
  ///

  setValues( data ){
    //console.log("setValues ZZZZZZ  " + data.investment);
    // Set values of individual Knobs
    this.refs.dpKnob.setKnobValue( data.downpayment );
    this.refs.mpKnob.setKnobValue( data.payments );
    this.refs.mKnob.setKnobValue( data.months );
    // Set values of Totals Display
    this.refs.display.setValues( data );
  }

  setKnobState(dpKnobData, mpKnobData, mKnobData, amount){

    dpKnobData.value_max = this.roundUp(dpKnobData.roundNumber, amount);
    
    mpKnobData.value_max = this.roundUp(
      mpKnobData.roundNumber,
      Math.round( amount / mKnobData.value_min )
    );

    this.setState({
      DownPaymentKnobSettings: dpKnobData,
      MonthlyPaymentsKnobSettings: mpKnobData,
      MonthsKnobSettings: mKnobData
    });

    
  }

  setKnobLock(e){
    // do things here to lock the knob
    let boo = e.value;// ? false : true;
    switch (e.id){
      case "dp":
        this.refs.dpKnob.setKnobLock( boo );
        this.setState({ dpKnobLocked: boo});
        //
        this.refs.mpKnob.setKnobLock( false );
        this.refs.mpLock.setToggle(false);
        //
        this.refs.mKnob.setKnobLock( false );
        this.refs.mLock.setToggle(false);
        //
        this.setState({ mpKnobLocked: false});
        this.setState({ mKnobLocked: false});
        break;
      case "mp":
        this.refs.mpKnob.setKnobLock( boo );
        this.setState({ mpKnobLocked: boo});

        this.refs.dpKnob.setKnobLock( false );
        this.refs.dpLock.setToggle(false);
        //
        this.refs.mKnob.setKnobLock( false );
        this.refs.mLock.setToggle(false);
        //
        this.setState({ dpKnobLocked: false});
        this.setState({ mKnobLocked: false});
        
        break;
      case "m":
        this.refs.mKnob.setKnobLock( boo );
        this.setState({ mKnobLocked: boo});
        //
        this.refs.dpKnob.setKnobLock( false );
        this.refs.dpLock.setToggle(false);
        //
        this.refs.mpKnob.setKnobLock( false );
        this.refs.mpLock.setToggle(false);
        //
        this.setState({ dpKnobLocked: false});
        this.setState({ mpKnobLocked: false});
        
        break;
      default:
        break;
    }

  }

  // Basis for the pay-in-full discount: initial treatment cost less additional
  // savings. Deliberately excludes the DRG fee and insurance coverage that are
  // folded into `investment`. Clamped at zero so savings larger than the
  // treatment cost cannot produce a negative discount.
  getDiscountBase(){
    let base = this.state.initialCost - this.state.discounts;
    return base > 0 ? base : 0;
  }

  getDiscountAmount(){
    return Math.round( this.getDiscountBase() * (this.state.perc / 100) );
  }

  showDiscountPopup(){
    if(this.state.showDiscount){
      // Nothing worth showing if the percentage is off or the basis nets to zero.
      if(this.state.perc > 0 && this.getDiscountAmount() > 0) this.onOpenModal();
      this.setState({showDiscount:false});
    }
  }

  onOpenModal = () => {
    this.setState({ modalOpen: true });
  };

  onCloseModal = () => {
    this.setState({ modalOpen: false });
  };

	render() {
    //const { modalOpen } = this.state; is this needed?
    return (
      <div>
          
          <Modal
            open={this.state.modalOpen}
            onClose={this.onCloseModal}
            little
            classNames={{
              modal: 'modal-custom',
              closeIcon: 'modal-custom-close'
            }}>

            <h2 className="modal-custom__header">{this.state.discountPopupHeaderLabel}</h2>
            <p className="modal-custom__content">
              {this.state.discountPopupContent}
            </p>
            <div className="fry-grid">
              <div className="fry-grid__1/1 fry-grid__auto@m">
                <h1 className="modal-custom__content-centered">{this.state.discountPriceLabel} ${this.state.investment - this.getDiscountAmount()}</h1>
              </div>
              <div className="fry-grid__1/1 fry-grid__1/4@m modal-custom__logo">
                <img src={logo} className="logo" alt="Fry Orthodontics Logo" />
              </div>
            </div>
          
          </Modal>
          
          <div className="fry-grid app-knob-container">

            <div className="fry-grid__1/1 fry-grid__1/12@m"></div>

            <div className="fry-grid__1/1 fry-grid__3/12@m">
              <div className="knob-container">

                <FryKnob ref="dpKnob"
                  roundNumber={ this.state.dpkRoundNumber }
                  settings={ this.state.DownPaymentKnobSettings }
                  onChange={ this.onDownPaymentChange }
                />

                <div className="lock-toggle">
                  <div className="lock-toggle-lock__sm">
                  <div className="lock-container__sm">
                      <Lock
                        className="knob-lock"
                        ref="dpLock"
                        onToggle={this.setKnobLock}
                        lockId="dp"
                      />
                    </div>
                  </div>
                  <div className="lock-toggle__text-sm">
                    <span className="">{this.state.downPaymentLockLabel}</span>
                  </div>
                </div>

              </div>
            </div>
            <div className="fry-grid__1/1 fry-grid__4/12@m">
              <div className="knob-container">

                <FryKnob ref="mpKnob"
                  roundNumber={ this.state.mpkRoundNumber }
                  settings={ this.state.MonthlyPaymentsKnobSettings }
                  onChange={ this.onMonthlyPaymentsChange }
                />

                <div className="lock-toggle">
                  <div className="lock-toggle-lock__lg">
                    <div className="lock-container__lg">
                      <Lock
                        className="knob-lock"
                        ref="mpLock"
                        onToggle={this.setKnobLock}
                        lockId="mp"
                      />
                    </div>
                  </div>
                  <div className="lock-toggle__text-lg">
                    <span className="">{this.state.monthlyPaymentsLockLabel}</span>
                  </div>
                </div>

              </div>
            </div>
            <div className="fry-grid__1/1 fry-grid__3/12@m">
              <div className="knob-container">
              
                <FryKnob ref="mKnob"
                  roundNumber={ this.state.mkRoundNumber }
                  settings={ this.state.MonthsKnobSettings }
                  onChange={ this.onMonthsChange }
                />

                <div className="lock-toggle">
                  <div className="lock-toggle-lock__sm">
                    <div className="lock-container__sm">
                      <Lock
                        className="knob-lock"
                        ref="mLock"
                        onToggle={this.setKnobLock}
                        lockId="m"
                      />
                    </div>
                  </div>
                  <div className="lock-toggle__text-sm">
                    <span className="">{this.state.monthsLockLabel}</span>
                  </div>
                </div>

              </div>
            </div>

          <div className="fry-grid__1/1 fry-grid__1/12@m"></div>
          
          <div className="fry-grid__1/1 instructions-spacing">


            <div className="fry-grid fry-m-t--xl fry-m-t--none@s fry-p--s fry-p--none@m">
                <div className="fry-grid__1/1 fry-grid__1/3@l">
         
                  <div className="fry-level">
                    <div>
                      <span className="fry-affix">
                        <label htmlFor="affix-example__00" className="fry-affix__prefix" aria-hidden="true" title="Dollars">$</label>
                        <input id="fee-amount" className="fry-input fry-affix__item" onChange={this.handleFeeInputUpdate} placeholder="0" type="number" name="fee-amount" />
                      </span>

                    </div>        
                    <div>
                      <button id="fee-button" onClick={this.handleAddFeeClick} className="fry-btn fry-btn--secondary" type="submit">
                        {this.state.feeButtonText}
                      </button>
                    </div>
                    
                  </div>

                </div>
                <div className="fry-grid__1/1 fry-grid__2/3@l">
                    
                  <Instructions
                    ref="instructions"
                    dpAmount={this.state.zeroMonthsDownPaymentMin}
                    mAmount={this.state.zeroDownPaymentMonthsMax}
                  />

                </div>
            </div>
          
            
          </div>

          <div className="fry-grid__1/1">
            <Totals ref="display"/>
          </div>
          
        </div>
      </div>

		);
	}
}

export default Payment;


// WEBPACK FOOTER //
// ./src/js/views/Payment/payment.js